import { render, staticRenderFns } from "./StatisticStudentWarnList.vue?vue&type=template&id=4bb6037f&scoped=true"
import script from "./StatisticStudentWarnList.vue?vue&type=script&lang=js"
export * from "./StatisticStudentWarnList.vue?vue&type=script&lang=js"
import style0 from "./StatisticStudentWarnList.vue?vue&type=style&index=0&id=4bb6037f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6037f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb6037f')) {
      api.createRecord('4bb6037f', component.options)
    } else {
      api.reload('4bb6037f', component.options)
    }
    module.hot.accept("./StatisticStudentWarnList.vue?vue&type=template&id=4bb6037f&scoped=true", function () {
      api.rerender('4bb6037f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/StatisticStudentWarnList.vue"
export default component.exports